import FullWidthModal from "components/FullWidthModal";
import ProfileMain from "./Component/ProfileMain";

export function Profile({ open, onClose }) {
  return (
    <FullWidthModal dir="rtl" title="پروفایل" open={open} onClose={onClose}>
      <ProfileMain />
    </FullWidthModal>
  );
}

export default Profile;
